"use client";

import React from "react";
import Image from "next/image";

interface LogoProps {
  className?: string;
  size?: number;
}

export const Logo: React.FC<LogoProps> = ({ className, size = 64 }) => {
  return (
    <Image
      src="/images/logo.png"
      alt="Rawej Logo"
      width={size}
      height={size}
      className={className}
      priority
    />
  );
};

export default Logo;

